import { TypeBxDonationCheckoutFormFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import BXDonationCheckoutForm from './BXDonationCheckoutForm'

const ContentfulBXDonationCheckoutForm = withContentful<TypeBxDonationCheckoutFormFields>(BXDonationCheckoutForm, {
  donation: (props) => props.fields?.donation,
  useEmbeddedForm: (props) => props.fields?.useEmbeddedForm,
  bxDonationFormHeight: (props) => props.fields?.bxDonationFormHeight,
})

export default ContentfulBXDonationCheckoutForm
